










import { Vue, Component } from 'vue-property-decorator';
import MantenedorCoordinadorBase from '@/pantallas/Conecta/MantenedorCoordinador/MantenedorCoordinadorBase.vue';

@Component({
  components: { MantenedorCoordinadorBase },
})
export default class MantenedorCoordinadorPantalla extends Vue {}
